var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuariosExcluidos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 300,
    viewBox: "0 0 64 64",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "LINE_60_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41.758 48.351c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l8.484-8.485c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-8.484 8.485c-.195.195-.451.293-.707.293z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_61_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m32.644 48.304h-14.296c-.553 0-1-.447-1-1 0-.552.447-1 1-1h14.296c.553 0 1 .448 1 1s-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_12_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56 34.311c-.553 0-1-.448-1-1v-4.789c0-2.038-1.657-3.696-3.695-3.696h-5.739c-.553 0-1-.447-1-1 0-.552.447-1 1-1h5.739c3.141 0 5.695 2.556 5.695 5.696v4.789c0 .551-.447 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_19_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.018 54.084c-.001 0-.001 0 0 0-2.702 0-5.285-.962-7.274-2.708-3.781-3.322-4.822-8.958-2.475-13.4 1.882-3.561 5.724-5.861 9.788-5.861.888 0 1.772.109 2.629.324 4.817 1.208 8.314 5.696 8.314 10.669 0 3.56-1.735 6.916-4.644 8.978-1.842 1.308-4.035 1.998-6.338 1.998zm.039-19.97c-3.332 0-6.48 1.883-8.021 4.796-1.92 3.634-1.067 8.244 2.027 10.963 1.624 1.426 3.738 2.211 5.953 2.211h.001c1.887 0 3.679-.563 5.183-1.629 2.379-1.688 3.8-4.435 3.8-7.347 0-4.069-2.86-7.741-6.801-8.73-.698-.175-1.419-.264-2.142-.264z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_40_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.348 48.304c-1.654 0-3-1.346-3-3 0-.552.447-1 1-1s1 .448 1 1 .448 1 1 1c.553 0 1 .448 1 1s-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_62_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.348 46.304c-.553 0-1-.447-1-1v-8.565c0-.552.447-1 1-1s1 .448 1 1v8.565c0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_41_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10 36.564c-1.654 0-3-1.346-3-3 0-.552.447-1 1-1s1 .448 1 1 .448 1 1 1c.553 0 1 .448 1 1 0 .553-.447 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_13_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8 34.564c-.553 0-1-.447-1-1v-5.043c0-3.141 2.555-5.696 5.695-5.696h5.739c.553 0 1 .448 1 1 0 .553-.447 1-1 1h-5.739c-2.038 0-3.695 1.658-3.695 3.696v5.043c0 .553-.447 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_63_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.348 36.564h-2.348c-.553 0-1-.447-1-1 0-.552.447-1 1-1h2.348c.553 0 1 .448 1 1 0 .553-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_42_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.591 24.793c-1.249 0-2.522-.334-3.713-1.016-2.884-1.65-4.26-4.75-3.506-7.898.728-3.038 3.261-5.179 6.453-5.452 3.207-.276 6.049 1.403 7.281 4.271.218.508-.017 1.096-.524 1.313-.504.217-1.096-.016-1.313-.523-1.076-2.504-3.42-3.227-5.272-3.069-1.846.158-4.044 1.272-4.679 3.926-.658 2.749.964 4.787 2.554 5.696 1.591.91 4.172 1.277 6.213-.687.398-.383 1.031-.371 1.414.027.383.397.371 1.03-.027 1.414-1.372 1.32-3.103 1.998-4.881 1.998z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_43_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.348 37.738c-.553 0-1-.447-1-1 0-4.435 3.608-8.043 8.044-8.043.553 0 1 .447 1 1 0 .552-.447 1-1 1-3.333 0-6.044 2.711-6.044 6.043 0 .553-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_64_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.608 30.695h-17.216c-.553 0-1-.448-1-1 0-.553.447-1 1-1h17.217c.553 0 1 .447 1 1-.001.552-.448 1-1.001 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_44_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45.426 24.781c-1.794 0-3.537-.678-4.896-1.986-.398-.383-.41-1.016-.027-1.413.384-.399 1.019-.411 1.414-.027 1.944 1.872 4.38 1.644 6.011.805 1.633-.841 3.236-2.691 2.843-5.366-.415-2.819-2.699-4.101-4.529-4.34-1.831-.239-4.377.41-5.51 3.035-.218.509-.81.74-1.313.523-.508-.219-.741-.808-.522-1.314 1.294-3.004 4.285-4.662 7.605-4.228 3.32.436 5.772 2.803 6.248 6.032.451 3.063-1.082 5.982-3.906 7.436-1.103.566-2.271.843-3.418.843z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_20_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.948 30.675c-1.77 0-3.508-.451-5.027-1.304-4.372-2.454-6.396-7.858-4.706-12.572 1.475-4.116 5.426-6.883 9.833-6.883.587 0 1.177.051 1.753.152 4.897.856 8.591 5.257 8.591 10.235 0 2.356-.811 4.665-2.283 6.5-1.946 2.425-4.997 3.872-8.161 3.872zm.1-18.759c-3.509 0-6.778 2.285-7.95 5.558-1.364 3.807.271 8.171 3.802 10.153 1.222.686 2.621 1.048 4.049 1.048 2.563 0 5.03-1.168 6.6-3.123 1.189-1.481 1.844-3.345 1.844-5.248 0-4.021-2.981-7.574-6.936-8.266-.464-.081-.937-.122-1.409-.122z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_65_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.242 48.351c-.256 0-.512-.098-.707-.293l-8.484-8.485c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l8.484 8.485c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuariosExcluidos);
export default __webpack_public_path__ + "static/media/usuarios_excluidos.9bb83fe6d8a5edc66f30bded94eac0f2.svg";
export { ForwardRef as ReactComponent };